import {keyframes} from '@emotion/react'
import {remCalc} from '_themeUtils'

const enterTextAnimation = keyframes`
    from {
        transform: translateX(150%);
    }
    to {
        transform: translateX(0);
    }
`

const getAlignment = (textAlign): string => {
    if (textAlign === 'left') return 'flex-start'
    if (textAlign === 'right') return 'flex-end'
    return 'center'
}

const getCtaJustify = (textAlign, ctaNum): string => {
    if (ctaNum === 1) {
        if (textAlign === 'left') return 'flex-start'
        if (textAlign === 'center') return 'center'
        if (textAlign === 'right') return 'flex-end'
    }

    return 'space-evenly'
}

const getTextPaddingTop = (insideAccordion, hasHeading, accordionTrigger): string => {
    if (insideAccordion && !hasHeading) return '0'
    if (accordionTrigger && hasHeading) return remCalc(17)
    return 'spacing.3'
}

const titleTextCta = {
    TitleTextCta: {
        baseStyle: ({
            textAlign,
            horizontalPosition,
            contentColor,
            contentBackground,
            textAnimation,
            fullHeight,
            ctaNum,
            insideAccordion,
            accordionTrigger,
            hasHeading,
        }) => ({
            wrapper: {
                w: '100%',
                gridColumn: '1 / -1', // Starts from the first column end ends at the last column
                backgroundColor: contentBackground,
                color: contentColor,
                ...(fullHeight && {
                    h: '100dvh',
                    display: 'flex',
                    alignItems: 'center',
                }),
            },
            container: {
                // Inside a 32_accordion the text width follows the Figma "Text accordion": full width on
                // mobile (the panel already insets 24px per side), 680px on tablet sm (md), 890px from lg up.
                w: insideAccordion ? {base: '100%', md: remCalc(680), lg: remCalc(890)} : '65%',
                maxW: insideAccordion ? '100%' : undefined,
                marginLeft: horizontalPosition === 'left' ? 'spacing.16' : 'auto',
                marginRight: horizontalPosition === 'right' ? 'spacing.16' : 'auto',
                alignItems: getAlignment(textAlign),
                textAlign: textAlign,
            },

            ctaContainer: {
                w: '100%',
                // Figma: 40px from the text to the CTA text. Already there: 8px stack gap + 8px CtaButton mt + 7px CtaButton py.
                mt: accordionTrigger ? remCalc(17) : undefined,
                flexDirection: {base: 'column', md: 'row'},
                alignItems: 'center',
                justifyContent: getCtaJustify(textAlign, ctaNum),
            },
            eyelet: {
                textStyle: 'paragraphLg',
                fontFamily: 'GTEesti',
                fontWeight: '300',
                mb: 'spacing.2',
            },
            title: {
                textStyle: 'displaySm',
                fontFamily: 'GTEesti',
                fontWeight: '400',
                animation: textAnimation ? `${enterTextAnimation} 1000ms cubic-bezier(.25,.1,.25,1)` : 'none',
            },
            text: {
                // Inside a 32_accordion the Figma "Text accordion" padding is owned by the panel, so a text
                // with no eyelet/title above it adds no top space of its own.
                // On the trigger module the Figma title-to-subtitle gap is 25px: 8px stack gap + 17px.
                pt: getTextPaddingTop(insideAccordion, hasHeading, accordionTrigger),
                // paragraph-md (16/20) on every breakpoint: Figma "Text accordion" and SFRA `.cc-text` agree.
                textStyle: 'paragraphMd',
            },
            // Chevron shown next to a CTA that targets a 32_accordion module (reflects open/closed state).
            accordionChevron: {
                ml: 'spacing.2',
            },
        }),
    },
}

export default titleTextCta
